import { IPreloadedState } from 'shared/types/redux';

export const selectTagsMeta = (state: IPreloadedState) => state.tags.meta;
